import { App, Select } from "antd";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import SelectLocationType from "@/components/Selector/SelectLocationType";


export const getDefaultOrderPreOutLocationTypes = (): number[] => {
  const defaultType = 1;
  return defaultType === undefined ? [] : [defaultType];
};

const useOrderPreOutLocationTypes = () => {
  const { modal, notification } = App.useApp();
  const { t } = useTranslation();

  return useCallback((): Promise<number[] | undefined> => {
    return new Promise(resolve => {
      let selectedTypes = getDefaultOrderPreOutLocationTypes();

      modal.confirm({
        title: t("inventory.locationType"),
        okText: t("common.confirm"),
        cancelText: t("common.cancel"),
        closable: true,
        keyboard: true,
        maskClosable: true,
        content: (
          <div>
            <div style={{ marginBottom: 8 }}>请选择出库</div>
            <SelectLocationType
              mode="multiple"
              style={{ width: "100%" }}
              placeholder={t("inventory.locationType")}
              defaultValue={selectedTypes}
              allowClear
              maxTagCount="responsive"
              onChange={(values) => {
                selectedTypes = values;
              }}
            />
          </div>
        ),
        onOk: () => {
          if (selectedTypes.length === 0) {
            notification.warning({
              placement: "top",
              message: t("common.selectLeastOne"),
            });
            return Promise.reject();
          }
          resolve(selectedTypes);
        },
        onCancel: () => {
          resolve(undefined);
        },
      });
    });
  }, [modal, notification, t]);
};

export default useOrderPreOutLocationTypes;
